const MAPS = {
    el: document.getElementById('map'),
    lat: 48.5735599,
    lang: 13.4212274,
    api: 'AIzaSyBVS5TFALc434clhMkNyPtL_yjzEayVR3E',
    acceptButton: document.getElementById('activate-maps'),
    onReady() {
        if (MAPS.acceptButton !== null) {
            MAPS.acceptButton.addEventListener('click', event => {
                event.preventDefault();
                MAPS.build();
            });
        }
    },
    build() {
        if (MAPS.el !== null) {
            let script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${MAPS.api}&callback=initMap`;
            script.defer = true;
            script.async = true;
            window.initMap = function() {
                const map = new google.maps.Map(MAPS.el, {
                    center: {
                        lat: MAPS.lat, 
                        lng: MAPS.lang
                    },
                    zoom: 15,
                    disableDefaultUI: true,
                    styles: [
                        {
                            "featureType": "all",
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "poi.park",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#aadd55"
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "visibility": "on"
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "labels.text",
                            "stylers": [
                                {
                                    "visibility": "on"
                                }
                            ]
                        },
                        {
                            "featureType": "road.local",
                            "elementType": "labels.text",
                            "stylers": [
                                {
                                    "visibility": "on"
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#0099dd"
                                }
                            ]
                        }
                    ]
                });
                const markerImage = {
                    url: 'https://www.immobilien-spitzenberger.de/dist/img/spitzenberger-maps-pin.png',
                    scaledSize: new google.maps.Size(35, 74),
                    optimized: false
                }
                const marker = new google.maps.Marker({
                    position: new google.maps.LatLng(MAPS.lat, MAPS.lang),
                    map: map,
                    icon: markerImage,
                    title: 'Spitzenberger Immobilien'
                });
            }
            document.head.appendChild(script);
        }
    }
}